import { Injectable } from '@angular/core';

import { StudentLifeCycle } from '@app/app.models';

@Injectable({
  providedIn: 'root',
})
export class StudentLifeCycleService {
  public getUserLifeCycle(
    studentStatus: string,
    isActivelyEngaged: boolean,
    hasTypeForm: boolean,
    hasNEPH: boolean,
    hasCode: boolean,
    hasCodeBooked: boolean,
    canDrive: boolean,
    hasStartedDriving: boolean
  ): StudentLifeCycle {
    const lifeCycles = new StudentLifeCycle();
    lifeCycles.isUserGuest = this.isGuest(studentStatus);
    lifeCycles.isUserRegistered = this.isRegistered(studentStatus);
    lifeCycles.isUserDrivingTraining = this.isDrivingTraining(studentStatus);
    lifeCycles.isUserWaitingForBooking = this.isWaitingForBooking(studentStatus);
    lifeCycles.isUserDrivingBooked = this.isDrivingBooked(studentStatus);
    lifeCycles.isUserDrivingSuccess = this.isDrivingSuccess(studentStatus);
    lifeCycles.isFrozen = this.isFrozen(studentStatus);
    lifeCycles.isUserEngaged = isActivelyEngaged;
    lifeCycles.isUserCanBookExamCode = this.canBookExamCode(hasNEPH, hasCode, hasCodeBooked);
    lifeCycles.isUserHasCodeBooked = hasCodeBooked;
    lifeCycles.isUserCanDrive = canDrive;
    lifeCycles.isUserStartedDriving = hasStartedDriving;
    lifeCycles.isUserNeedCompleteRegistration = this.needCompleteRegistration(hasTypeForm, hasNEPH);
    lifeCycles.isUserNeedEnterNEPH = this.needEnterNEPH(hasNEPH);

    return lifeCycles;
  }

  private isGuest(studentStatus: string) {
    return !studentStatus || studentStatus == 'guest';
  }

  private isRegistered(studentStatus: string) {
    return studentStatus == 'registered';
  }

  private isDrivingTraining(studentStatus: string) {
    return studentStatus == 'driving_training';
  }

  private isWaitingForBooking(studentStatus: string) {
    return studentStatus == 'waiting_for_booking';
  }

  private isDrivingBooked(studentStatus: string) {
    return studentStatus == 'driving_booked';
  }

  private isDrivingSuccess(studentStatus: string) {
    return studentStatus == 'driving_success';
  }

  private isFrozen(studentStatus: string) {
    return studentStatus == 'frozen';
  }

  private canBookExamCode(hasNEPH: boolean, hasCode: boolean, hasCodeBooked: boolean) {
    return hasNEPH && !hasCode && !hasCodeBooked;
  }

  private needCompleteRegistration(hasTypeForm: boolean, hasNEPH: boolean) {
    return !hasTypeForm && !hasNEPH;
  }

  private needEnterNEPH(hasNEPH: boolean) {
    return !hasNEPH;
  }
}
